import styled from 'styled-components';

export const PageWrapper = styled.div`
  box-sizing: border-box;
  padding: 20px;
  height: calc(100vh - 20px);
  background-color: white;
`
